// stocai_frontend/src/components/HomePage/components/widgets/Module7/Steps/FutureSequence.jsx

import React from "react";
import AutoTimelineSequence from "../../../MilestoneSequence/AutoTimelineSequence.jsx";
import StakeholderCardWithData from "../../Stakeholders/stakeholderValuesAndInterests/StakeholderCardWithData.jsx";
import MeetingPersonalityCard from "../../Module4/MeetingPersonalityCard.jsx";
import CurrentStateProfileCard from "../../Identity/CurrentYou/CompletionPages/CurrentStateProfileCard.jsx";
import UnmetNeedsCard from "../../UnmetNeeds/UnmetNeedsCard.jsx";
import StakeholderListCard from "../../Stakeholders/StakeholderListCard.jsx";
import NarrativeCompletionCard from "../../Module6/Steps Building Narrative/NarrativeCompletionCard";
import FuturePersonaCard from "../FuturePersonaCard.jsx";
import FutureIdentityCard from "../../Identity/FutureYou/FutureIdentityCard.jsx";

/**
 * Auto-playing future journey sequence for Module 7.
 * Replays narrative steps, then Future Persona, then Future Identity with core values.
 *
 * Props:
 *  - userId
 *  - onNextStep
 *  - selectedCard (optional) : for NarrativeCompletionCard
 *  - futureData (optional)   : for FutureIdentityCard
 *  - coreValues (optional)   : for FutureIdentityCard
 *  - behaviours/beliefs/risks: arrays of strings for FuturePersonaCard
 */
const FutureSequence = ({
  userId,
  onNextStep,
  selectedCard,
  futureData = {},
  coreValues = [],
  behaviours = [],
  beliefs = [],
  risks = [],
}) => {
  const safeFutureData = futureData || {};

  const steps = [
    {
      position: "center",
      circles: { left: "", center: "", right: "Future Identity" },
      component: CurrentStateProfileCard,
      props: { mode: "api", userId },
      duration: 5000,
    },
    {
      position: "left",
      circles: { left: "", center: "Value Mapping", right: "Value & Pitch" },
      component: UnmetNeedsCard,
      props: { mode: "api", userId },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "1st Meeting with Career Coach",
        center: "",
        right: "Visibility Mapping",
      },
      component: StakeholderListCard,
      props: { mode: "api", userId },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "Visibility Mapping",
        center: "",
        right: "What's in it for me?",
      },
      component: StakeholderCardWithData,
      props: { mode: "api", userId },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "What's in it for me?",
        center: "",
        right: "2nd Meeting...",
      },
      component: MeetingPersonalityCard,
      props: { mode: "api", userId },
      duration: 5000,
    },
    // Original narrative completion card
    {
      position: "center",
      circles: {
        left: "2nd Meeting with Career Coach",
        center: "",
        right: "3rd Meeting with Career Coach",
      },
      component: NarrativeCompletionCard,
      props: {
        heroTitle: selectedCard?.name || "My Narrative",
        heroSubtitle: selectedCard?.tagline || "",
        bullets: Array.isArray(selectedCard?.bullets)
          ? selectedCard.bullets
          : [],
      },
      duration: 5000,
    },
    // Persona card with real data
    {
      position: "center",
      circles: {
        left: "3rd Meeting with Career Coach",
        center: "",
        right: "Action Plan",
      },
      component: FuturePersonaCard,
      props: {
        behaviours,
        beliefs,
        risks,
      },
      duration: 5000,
    },
    // Final future identity card with core values
    {
      position: "center",
      circles: {
        left: "Action Plan",
        center: "",
        right: "",
      },
      component: FutureIdentityCard,
        props: {
          futureData: safeFutureData,
          userName: safeFutureData.userName,
          profileImage: safeFutureData.profileImageUrl,
          currentInput: "",
          coreValues,
          showCoreValues: true,
        },
      duration: 5000,
      final: true,
    },
  ];

  return <AutoTimelineSequence steps={steps} onComplete={onNextStep} />;
};

export default FutureSequence;
